module.exports = __webpack_public_path__ + "img/plug_online.c8b35514.png";